module.exports = __webpack_public_path__ + "img/bitgertlogo.51109f52.png";